export default "__VITE_ASSET__CmsBgkni__"